import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown>[];
}

export default function SEOMeta({ title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType = 'website', jsonLd }: SEOMetaProps) {
  useEffect(() => {
    document.title = title;
    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', canonicalUrl);
    else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }

    setMeta('og:title', ogTitle || title, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('twitter:title', ogTitle || title);
    setMeta('twitter:description', ogDescription || description);

    // JSON-LD
    if (jsonLd && jsonLd.length > 0) {
      const existingScripts = document.querySelectorAll('script[data-dynamic-ld]');
      existingScripts.forEach((s) => s.remove());

      jsonLd.forEach((ld) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-dynamic-ld', 'true');
        script.textContent = JSON.stringify(ld);
        document.head.appendChild(script);
      });
    }

    return () => {
      const scripts = document.querySelectorAll('script[data-dynamic-ld]');
      scripts.forEach((s) => s.remove());
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, jsonLd]);

  return null;
}

function setMeta(name: string, content: string, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}